import dayjs from 'dayjs';

import request from '../utils/Request';
import { Methods, NotificationType } from '../config';
import { downloadFile } from '../utils/download';
import { ResponseType } from '../config/responetype';
import addNotification from '../utils/addNotification';

const baseURL = 'employee';

const employeeService = {
  getEmployeeById: (id) => {
    return request({
      method: Methods.GET,
      resource: `${baseURL}/employee/${encodeURIComponent(id)}`,
    });
  },

  getEmployees: (data) => {
    return request({
      method: Methods.POST,
      resource: `${baseURL}/employees`,
      data,
    });
  },

  checkConsistency: (data) => {
    return request({
      method: Methods.POST,
      resource: `${baseURL}/consistencyCheck`,
      data,
    });
  },

  createEmployee: (data) => {
    return request({
      method: Methods.POST,
      resource: `${baseURL}`,
      data,
    });
  },

  updateEmployee: (data) => {
    return request({
      method: Methods.PUT,
      resource: `${baseURL}`,
      data,
    });
  },

  deleteEmployee: (data, id) => {
    return request({
      method: Methods.DELETE,
      resource: `${baseURL}/${encodeURIComponent(id)}`,
      data,
    });
  },

  orderEmployee: (id, data) => {
    return request({
      method: Methods.POST,
      resource: `${baseURL}/orderEmployee/${encodeURIComponent(id)}`,
      data,
    });
  },

  getClassificationBySubMenuId: (subMenuId) => {
    return request({
      method: Methods.POST,
      resource: `${baseURL}/classificationItems/${encodeURIComponent(subMenuId)}`,
    });
  },

  getExcelTemplate: async () => {
    const excelFromServer = await request({
      responseType: 'blob',
      resource: `${baseURL}/exceltemplate`,
    });
    return downloadFile(excelFromServer, `Dolgozok_template-${dayjs().format('YYYYMMDD_HHmm')}.xlsx`);
  },

  getExcelData: async () => {
    const excelFromServer = await request({
      responseType: 'blob',
      resource: `${baseURL}/exceldata`,
    });
    return downloadFile(excelFromServer, `Dolgozok-${dayjs().format('YYYYMMDD_HHmm')}.xlsx`);
  },

  importExcel: async (files, userId) => {
    const formData = new FormData();

    for (const file of files) {
      formData.append('files', file);
    }
    formData.append('userId', userId);

    const resp = await request({
      method: Methods.POST,
      resource: `${baseURL}/excelimport`,
      formData: true,
      data: formData,
      responseType: 'blob',
    });

    if (resp?.type === ResponseType.xlsx) {
      addNotification({
        content: 'Az import sikertelen!',
        type: NotificationType.ERROR,
      });

      downloadFile(resp, `ERR_${files[0].name}`);
      return Promise.reject(new Error('Error in uploaded file!'));
    }

    const reader = new FileReader();
    reader.readAsText(resp);
    reader.onload = () => {
      const jsonData = JSON.parse(reader.result);
      if (jsonData?.error?.message) {
        return addNotification({
          content: jsonData.error.message,
          type: NotificationType.ERROR,
        });
      }
      return jsonData.data;
    };
  },

  uploadFile: (file, id, userId) => {
    const formData = new FormData();
    formData.append('files', file);
    formData.append('userId', userId);

    return request({
      method: Methods.POST,
      resource: `${baseURL}/uploadFile/${encodeURIComponent(id)}`,
      formData: true,
      data: formData,
    });
  },

  deleteFile: (id, userId) => {
    return request({
      method: Methods.DELETE,
      resource: `${baseURL}/deleteFile/${encodeURIComponent(id)}`,
      data: { userId },
    });
  },
};

export default employeeService;
